import { fromJS } from 'immutable';
import * as constants from './constants';
import R, { equals } from 'ramda';
const initialState = fromJS({
  contractingPartners: [], // this is contracting partners
  newPartnersSelected: [],
  partnersToSendTo: [],
  loadingExisting: false,
  existingConnections: [],
  filteredConnections: [],
  selectedExistingPartners: [], // this is NOT contracting partners, just partners from connections
  gettingRequests: false,
  sendToPartners: true,
  addPartnersMethod: '',
  showAddIndividuallyDialog: false,
  showSelectFromPartnersDialog: false,
  showUploadFileDialog: false,
  showEmailImportDialog: false,
  individualCompanyName: '',
  individualEmail: '',
  searchField: '',
  finishing: false,
  processingPartners: false,
});

export default function partnerReducer(state = initialState, { type, payload }) {
  switch (type) {
    case 'UPDATE_CONTRACTING_SEND_TO_PARNTNERS_WITH_KEYPATH':
      return state.setIn(payload.keyPath, payload.immutableValue);
    case constants.LOADING_EXISTING_CONNECTIONS:
      return state.set('loadingExisting', true);
    case constants.GOT_CONTRACTING_PARTNERS:
      return state.set('contractingPartners', payload ? fromJS(payload) : undefined);
    case constants.GOT_EXISTING_CONNECTIONS:
      return state.set('existingConnections', fromJS(payload)).set('loadingExisting', false);
    case constants.PROCESSING_PARTNERS:
      return state.set('processingPartners', !state.get('processingPartners'));
    case constants.UPDATE_PROPS:
    case constants.PARTNERS_PROCESSED:
      const newPartnersSelected = R.differenceWith(R.ifElse(
        R.prop('companyId'),
        R.eqProps('companyId'),
        R.eqProps('email')
      ), payload.partnersToSendTo || state.get('partnersToSendTo').toJS(), state.get('contractingPartners').toJS());
      return state.merge(fromJS(payload)).set('newPartnersSelected', fromJS(newPartnersSelected));
    case constants.CHECK_CONNECTION:
      if (equals(payload.checkType, 'checkOne')) return state.update('selectedExistingPartners', selected => selected.push(fromJS(payload.partner)));
      return state.set('selectedExistingPartners', equals(state.get('filteredConnections').size, 0) ? state.get('existingConnections') : state.get('filteredConnections'));
    case constants.UNCHECK_CONNECTION:
      if (equals(payload.checkType, 'uncheckOne')) return state.update('selectedExistingPartners', selected => selected.filterNot(equals(fromJS(payload.partner))));
      return state.set('selectedExistingPartners', fromJS([]));
    case constants.GOT_REQUESTS:
      return state
      .update('partnersToSendTo', list => list.concat(fromJS(
        R.uniqBy(R.prop('buyerId'), payload)
        .map(request => ({
          profileImageUrl: request.buyerProfileImageUrl,
          companyName: request.buyerCompanyName,
          company_name: request.buyerCompanyName,
          companyId: request.buyerId,
          _type: 'Contractor',
          email: 'via TourConnect',
          connectionStatus: 'pending',
          contracts: [],
        })))))
      .set('requestsLoaded', true)
      .set('gettingRequests', false);
    case 'CLEAR_STORE_SUPPLIER_SEND_TEMPLATE_WIZARD':
    case 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD':
    case constants.CLEAR_STORE:
      return state.merge(fromJS({
        selectedExistingPartners: [],
        partnersToSendTo: [],
      }));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/send-to-partners/reducer.js